<ms-regular-option-group
    *ngIf="!showLinkedGroup"
    [event]="event"
    [optionGroup]="optionGroup"
    [groupType]="groupType"
    [thresholds]="thresholds"
    [tracking]="tracking"
    [trackingModuleType]="trackingModuleType"
    [calendarTrack]="calendarTrack"
    [showMarketHelp]="showMarketHelp"
    [crmPromotedOptionIdsMap]="crmPromotedOptionIdsMap"
    [sourceOfPick]="sourceOfPick"
    [eventHelpText]="eventHelpText"
    [betDetails]="betDetails"
    [optionsLimitOverride]="optionsLimitOverride"
    [showPlayerStats]="showPlayerStats"
    (expandClicked)="onExpandedClicked($event)"
    (showAllRequested)="showAllRequested.next()"></ms-regular-option-group>
<ms-linked-option-group
    *ngIf="showLinkedGroup"
    [fixture]="event.winGameLinkedFixture"
    [parentLinkedEventId]="event.id"
    [groupName]="optionGroup.name"
    [crmPromotedOptionIdsMap]="crmPromotedOptionIdsMap"
    [thresholds]="thresholds"></ms-linked-option-group>
